import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from 'lodash';

import * as actions from "../../../store/actions";

import {
  Paper, Container, Table, TableBody, TableRow, TableCell,
  TextField, Switch, TableFooter, TablePagination, Typography, CircularProgress
} from '@mui/material';
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import TableActionConfirmButtons from "../../../UI/MaterialTableOverrides/TableActionConfirmButtons";
import TableActionButtons from "../../../UI/MaterialTableOverrides/TableActionButtons";
import EnhancedTableHead from '../../../UI/MaterialTableOverrides/EnhancedTableHead';
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import { deleteCheckMessage } from '../../../utils/deleteCheckMessage';
import {
  Appbar,
} from '../../Login/styles';

const Quicksight = () => {

  const dispatch = useDispatch();

  let textInput = useRef(null);

  const [alreadySerched, setAlreadySerched] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [actionRow, setActionRow] = useState("");
  const [editedIndex, setEditedIndex] = useState(-1);
  const [orderBy, setOrderBy] = useState("UserName");
  const [order, setOrder] = useState("desc");

  const fetchQuicksight = useCallback(
    () => dispatch(actions.fetchQuicksight(page, limit, searchText, order, orderBy)),
    [page, limit, searchText, order, orderBy]
  );

  const deleteQuicksight = (index, page, limit, searchText, order, orderBy) => dispatch(actions.deleteQuicksight(index, page, limit, searchText, order, orderBy))
  const updateQuicksight = (index, body, page, limit, searchText, order, orderBy) => dispatch(actions.updateQuicksight(index, body, page, limit, searchText, order, orderBy))
  const postQuicksight = (body, page, limit, searchText, order, orderBy) => dispatch(actions.postQuicksight(body, page, limit, searchText, order, orderBy))


  const permissions = useSelector(state => state.quicksight.permissions);
  const loading = useSelector(state => state.quicksight.loading);
  //FALTA O CHECKDELETE

  const [isAddingPermission, setIsAddingPermission] = useState(false);

  const [UserName, setUserName] = useState("");
  const [tenant, setTenant] = useState(0);

  const headRows = [
    { id: "actions", numeric: false, disablePadding: false, label: "Ações" },
    { id: "UserName", numeric: false, disablePadding: false, label: "User Name" },
    { id: "tenant", numeric: false, disablePadding: false, label: "Tenant" },
  ];

  useEffect(() => {
    fetchQuicksight(page, limit, searchText, order, orderBy);
    setAlreadySerched(true);
  }, [page, limit, order, orderBy]);

  useEffect(() => {
    if (searchText !== "" || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchQuicksight(page, limit, searchText, order, orderBy);
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const handleChangePage = (e, page) => {
    setEditedIndex(-1);
    setPage(page + 1);
    setIsAddingPermission(false)
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
    setEditedIndex(-1);
    setIsAddingPermission(false)
  };

  //Styles
  const styles = {
    table: {
			position: 'relative',
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    },
    paper: {
      marginTop: 90,
    },
  }

  const editUserName = () => {
    return (
      <TextField
        variant="standard"
        style={styles.editWidth}
        id="username"
        label='UserName'
        value={UserName}
        margin="normal"
        onChange={event => {
          setUserName(event.target.value);
        }} />
    );
  };

  const editTenant = () => {
    return (
      <TextField
        variant="standard"
        style={{width: "100%"}}
        id="tenant"
        label='Tenant'
        value={tenant}
        margin="normal"
        onChange={(event) => {
            setTenant(event.target.value);
        }} />
    );
  };

  const addingPermission = () => {
    setIsAddingPermission(!isAddingPermission);

    setUserName("");
    setTenant("");

    setEditedIndex(-1);
  };

  const createComponent = () => {
    postQuicksight({ UserName: UserName, tenant: tenant }).then((res) => {
      if (res === 'success') {
        setIsAddingPermission(false)
        fetchQuicksight();
      }
    })
  }

  const deleteComponent = (index, objIndex) => {
    //fetchCheckDelete(objIndex);
    setEditedIndex(index);
    setActionRow('deleting');
  };

  const editComponent = (index, obj) => {
    setEditedIndex(index);

    setUserName(obj.UserName);
    setTenant(obj.tenant);

    setActionRow('editing');
    setIsAddingPermission(false);
  };

  const updateComponent = (index) => {
    if (actionRow === 'editing') {
      if (UserName === '') return;
      updateQuicksight(index, { UserName: UserName, tenant: tenant })
        .then((res) => {
          if (res === 'success') {
            setEditedIndex(-1);
            fetchQuicksight();
          }
        })
    } else if (actionRow === 'deleting') {
      deleteQuicksight(index).then((res) => {
        if (res === 'success') {
          setEditedIndex(-1);
          fetchQuicksight();
        }
      })
    }
  };

  const cancelEdit = () => {
    setEditedIndex(-1);
  };

  const createCancel = () => {
    setIsAddingPermission(false);
  };

  return <>
  <Appbar title={'geequip'} />
  <div style={styles.paper}>
    <Container maxWidth="lg">
      <Paper>
        <TableTitle
          title="Permissões Quicksight"
          placeholder="Pesquisar por permissões"
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPage(1);
            setSearchText(event.target.value);
          }}
          addRow={() => addingPermission()}
        />
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <CircularProgress />
                  </div>}
                {permissions.rows.length === 0 && !isAddingPermission &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>Nenhum resultado encontrado</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={styles.opacityContainer}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody style={styles.opacityContainer}>
            {isAddingPermission && (
              <TableRow>
                <TableActionConfirmButtons
                  createComponent={createComponent}
                  createCancel={createCancel}
                />
                <TableCell>{editUserName()}</TableCell>
                <TableCell>{editTenant()}</TableCell>
              </TableRow>
            )}
            {permissions.rows.map((permission, index) => (
              <TableRow key={permission._id}>
                <TableActionButtons
                  objContent={permission}
                  deleteComponent={deleteComponent}
                  editComponent={editComponent}
                  updateComponent={updateComponent}
                  cancelEdit={cancelEdit}
                  editedIndex={editedIndex}
                  index={index}
                  action={actionRow}
                  checkDelete={true}
                />
                <TableCell>
                  {index === editedIndex ?
                    actionRow === "editing" ?
                      editUserName() :
                      <Typography variant='h7' style={styles.deleteTextConfirm}>
                        Deseja realmente deletar esse item?
                      </Typography> :
                      permission.UserName}
                </TableCell>
                <TableCell>
                  {index === editedIndex ?
                    actionRow === "editing" ?
                      editTenant() :
                      "" :
                      permission.tenant}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter style={styles.opacityContainer}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={permissions.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </Container>
  </div>
  </>;
}

export default Quicksight;

